import React from "react";
import { useLanguage } from "../context/LanguageContext";
import { translations } from "../translations";

export const About = (props) => {
  const { language } = useLanguage();
  const t = translations.about[language] || translations.about.en;
  const tc = translations.contact[language] || translations.contact.en;

  return (
    <section id="about">
      <div className="container">
        <div className="about-grid">
          <div className="about-visual">
            <div className="about-card-main">
              <div className="big-number">12+</div>
              <div className="label">{language === 'en' ? 'Years of Excellence' : language === 'hi' ? 'उत्कृष्टता के वर्ष' : language === 'pa' ? 'ਉੱਤਮਤਾ ਦੇ ਸਾਲ' : "Années d'Excellence"}</div>
            </div>
            <div className="about-stats-row">
              <div className="about-stat">
                <strong>50+</strong>
                <span>{language === 'en' ? 'Projects' : language === 'hi' ? 'प्रोजेक्ट्स' : language === 'pa' ? 'ਪ੍ਰੋਜੈਕਟਸ' : 'Projets'}</span>
              </div>
              <div className="about-stat">
                <strong>30+</strong>
                <span>{language === 'en' ? 'Clients' : language === 'hi' ? 'क्लाइंट्स' : language === 'pa' ? 'ਗਾਹਕ' : 'Clients'}</span>
              </div>
              <div className="about-stat">
                <strong>5+</strong>
                <span>{language === 'en' ? 'Countries' : language === 'hi' ? 'देश' : language === 'pa' ? 'ਦੇਸ਼' : 'Pays'}</span>
              </div>
            </div>
          </div>
          <div className="about-content">
            <span className="section-label">{t.title}</span>
            <h2>{t.subtitle}</h2>
            <p>{t.description}</p>
            <p>{t.mission}</p>
            
            <div className="about-features">
              <div className="about-feature">
                <span className="check">✓</span>
                <span>{language === 'en' ? 'Expert Development Team' : language === 'hi' ? 'विशेषज्ञ डेवलपमेंट टीम' : language === 'pa' ? 'ਮਾਹਰ ਡਿਵੈਲਪਮੈਂਟ ਟੀਮ' : 'Équipe de Développement Expert'}</span>
              </div>
              <div className="about-feature">
                <span className="check">✓</span>
                <span>{language === 'en' ? 'Agile Methodology' : language === 'hi' ? 'एजाइल मेथडोलॉजी' : language === 'pa' ? 'ਐਜਾਇਲ ਮੈਥਡੋਲੋਜੀ' : 'Méthodologie Agile'}</span>
              </div>
              <div className="about-feature">
                <span className="check">✓</span>
                <span>{language === 'en' ? '24/7 Support' : language === 'hi' ? '24/7 सपोर्ट' : language === 'pa' ? '24/7 ਸਹਾਇਤਾ' : 'Support 24/7'}</span>
              </div>
              <div className="about-feature">
                <span className="check">✓</span>
                <span>{language === 'en' ? 'Transparent Pricing' : language === 'hi' ? 'पारदर्शी मूल्य निर्धारण' : language === 'pa' ? 'ਪਾਰਦਰਸ਼ੀ ਮੁੱਲ ਨਿਰਧਾਰਨ' : 'Tarification Transparente'}</span>
              </div>
            </div>
            
            <a href="#contact" className="btn btn-primary page-scroll">
              {tc.sendButton}
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
